import {
  CSSReset,
  Flex,
  FormLabel,
  Heading,
  Switch,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  ThemeProvider,
} from '@chakra-ui/core';
import React, { useState } from 'react';
import ConnectChart from './ConnectChart';
import DynamicComparison from './DynamicComparison';
// eslint-disable-next-line
import { useFetchDynamicDataSets } from './hooks';

interface DynamicProps {
  includeComparison?: boolean;
}

const Dynamic: React.FC<DynamicProps> = ({ includeComparison }) => {
  const [quarterly, setQuarterly] = useState(false);
  return (
    <ThemeProvider>
      <CSSReset />
      <Tabs position="relative" fontFamily="Aeonik">
        <Flex justify="space-between" align="center">
          <Heading ml={{ xs: '0px', md: '133px' }} as="h5" fontFamily="Aeonik" fontSize={{ xs: 'lg', md: 'xl' }}>
            Rendement
          </Heading>
          <TabList gridGap="2" borderBottom="none">
            <Tab
              fontWeight="600"
              backgroundColor="gray.100"
              _selected={{ backgroundColor: '#2E3A44', color: '#F9F8F7' }}
            >
              Sicav
            </Tab>
            <Tab
              fontWeight="600"
              backgroundColor="gray.100"
              _selected={{ backgroundColor: '#2E3A44', color: '#F9F8F7' }}
            >
              Sinds oprichting
            </Tab>
          </TabList>
        </Flex>

        <TabPanels
          mt={{ xs: '70px', md: '130px' }}
          py={{ xs: '70px', md: '130px' }}
          px={{ xs: '40px', md: '133px' }}
          backgroundColor="#F9F8F7"
        >
          <TabPanel>
            <Flex justify="end" w="full">
              <FormLabel>Per kwartaal</FormLabel>
              <Switch mr={6} size="sm" isChecked={quarterly} onChange={() => setQuarterly(!quarterly)} />
            </Flex>
            <ConnectChart
              startDate={new Date('2021-10-01')}
              useFetchDataSets={useFetchDynamicDataSets({ quarterly })}
              quarterly={quarterly}
              comparison={includeComparison && <DynamicComparison />}
            />
          </TabPanel>
          <TabPanel>
            <Flex justify="end" w="full">
              <FormLabel>Per kwartaal</FormLabel>
              <Switch mr={6} size="sm" isChecked={quarterly} onChange={() => setQuarterly(!quarterly)} />
            </Flex>
            <ConnectChart
              startDate={new Date('2020-10-12')}
              useFetchDataSets={useFetchDynamicDataSets({
                includeFic: true,
                quarterly,
              })}
              quarterly={quarterly}
              comparison={includeComparison && <DynamicComparison />}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </ThemeProvider>
  );
};

export default Dynamic;
